import React from 'react';
import { useLocation } from "react-router-dom";

import { Page } from "src/pages/_partials/Layout";
import NavBar2 from 'src/componets/NavBar2';
import ghMarketUrls from "src/configs/gh_market/ghMarketUrls";

interface PropsInterface {
  className?: string;
  children: React.ReactNode
}

const PageLayout: React.FC<PropsInterface> = (props) => {
  const PAGES: {[index: number]: any} = {
    1: {
      id: 1,
      name: 'Bundles',
      icon: 'fa-brands fa-app-store-ios',
      url: ghMarketUrls.bundlesPath()
    },
  };

  const PARENT_PAGE_IDS = [1];
  const PAGE_IDS = Object.keys(PAGES).map(id => parseInt(id, 10));

  const { pathname } = useLocation();
  const pageId = PAGE_IDS.find(id => {
    if (!PAGES[id].url) return false;
    const pagePath = PAGES[id].url.split('?')[0];
    return pathname.startsWith(pagePath);
  });

  return (
    <Page className={props.className}>
      <NavBar2 items={PAGES} itemIds={PARENT_PAGE_IDS} activeId={pageId} />

      <div className='v-layout--body'>
        {props.children}
      </div>
    </Page>
  );
}

export default PageLayout;
